import { Link } from 'react-router-dom';

interface ForbiddenPageProps {
  message?: string;
  orgSlug?: string;
}

export function ForbiddenPage({ message, orgSlug }: ForbiddenPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <div className="text-6xl font-bold text-gray-300 mb-4">403</div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Access Forbidden</h1>
        <p className="text-gray-600 mb-6">
          {message || (orgSlug
            ? `You don't have permission to access the organization "${orgSlug}".`
            : "You don't have permission to access this resource.")}
        </p>
        <div className="space-x-4">
          <Link
            to="/home"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
